import Store from '@/store/computed/storeHelpers'
import Api from '@/services/api'
export default {
  methods: {
    getContractors() {
      this.loadingContractors = true
      var urlString = 'contractors'
      if (!!this.includeInactive) urlString += '/includeInactive'
      return Api.get(urlString)
        .then(result => {
          this.loadingContractors = false
          this.contractors = result.data.result
          this.activeContractors = result.data.result.filter(contractor => {
            return contractor.active && !contractor.request
          })
          return result.data.result
        })
        .catch(err => {
          console.log(err)
          this.loadingContractors = false
          this.snackError()
        })
    }
  },
  computed: {
    loadingContractors: Store.getSet({
      store: 'contractors',
      prop: 'loadingContractors'
    }),
    contractors: Store.getSet({ store: 'contractors', prop: 'contractors' }),
    activeContractors: Store.getSet({
      store: 'contractors',
      prop: 'activeContractors'
    })
  },
  mounted() {
    if (!this.contractors.length && this.$route.name !== 'audit') {
      this.getContractors()
    }
  },
  beforeDestroy() {
    if (!this.keepMasterFiles) this.contractors = []
  }
}
